import { Injectable } from '@angular/core';
import { MetricasService } from './metricas.service';


@Injectable({
  providedIn: 'root',
})

export class PostHogService {

    constructor(private metricas: MetricasService) { }

    async identify(company_id:any, rut:string, business_name:string){



    }

    // Los eventos de negocio que ya se capturaban aquí (login, registro, onboarding...) van al
    // dashboard de métricas de lemu, junto con las pantallas y diálogos que mide MetricasService.
    async capture(vista:string, code:any, endpoint:any, description:string, platform:string, paso_onboarding?:any){

        const success = code == 200 || code == 201;
        const data: any = { success, cause: description, endpoint, status: code, evento: vista };
        if (paso_onboarding !== undefined) {
            data.paso_onboarding = paso_onboarding;
        }

        let tipo = 'evento';
        if (vista === 'login') {
            tipo = 'login';
            data.method = String(endpoint).includes('verify-code') ? 'codigo' : 'password';
        } else if (vista === 'register' || (vista === 'landing' && String(endpoint).includes('signup'))) {
            tipo = 'register';
            data.origen = vista === 'landing' ? 'landing-portal' : 'portal';
        }

        this.metricas.guardarMetrica({ tipo_metrica: tipo, data });
    }


    user_name:string="";
    set_username(user_name:string){
        this.user_name = user_name;
    }

    get_username(){
        return this.user_name;
    }



}
